export default __webpack_public_path__ + "static/TimesNow-SemiLight-04233c850f2ff5530b66a33f55a5970a.woff";